'use client'

import { createContext, useContext } from 'react'

import Shepherd, { Tour } from 'shepherd.js'

export const ShepherdTourContext = createContext<{
  tour: Tour | undefined
}>({
  tour: undefined,
})

export const ShepherdTourProvider = ({ children }: { children: React.ReactNode }) => {
  const shepherdTourInstance = new Shepherd.Tour({
    confirmCancel: true,
    confirmCancelMessage:
      'Are you sure you want to stop the tour? If so, you can always restart the tour by going to the resume menu with the three dots on the top right.',
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
    },
    useModalOverlay: true,
  })
  return (
    <ShepherdTourContext.Provider value={{ tour: shepherdTourInstance }}>
      {children}
    </ShepherdTourContext.Provider>
  )
}

export const useShepherdTour = () => {
  const context = useContext(ShepherdTourContext)

  if (!context) {
    throw new Error('useShepherdTour must be used within a ShepherdTourProvider')
  }

  return context
}
